<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="대화문을 학습 합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <perfect-scrollbar>
        <div id="component-chat-log" v-if="chatData" class="inner-scroll-height">
          <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">

            <div class="flex items-start" :class="[{'flex-row-reverse' : msg.isSent}]">

                <!-- <template v-if="chatData[index-1]">
                  <template v-if="(!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent))">
                    <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" src="https://i.imgur.com/ezM6SJ5.png"></vs-avatar>
                  </template>
                </template>

                <template v-if="index == 0">
                  <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" src="https://i.imgur.com/ezM6SJ5.png"></vs-avatar>
                </template> -->

                <!-- <template v-if="chatData[index-1]">
                    <div class="mr-16" v-if="!(!hasSentPreviousMsg(chatData[index-1].isSent, msg.isSent))"></div>
                </template> -->

              <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm" :class="{'bg-primary-gradient text-white': msg.isSent, 'border border-solid border-transparent bg-white': !msg.isSent}">
                <span>{{ msg.sentence }}</span>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>

      <div class="text-center" >
        <audio ref="audioPlayer" 
            controls
            hidden
            v-on:ended="audioFinish" 
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>

</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    PerfectScrollbar
  },
  data () {
    return {
      isStart: false,
      contentList: [],
      hint: true,
      contentIndex: 0,
      finished: false,
      chatData:[],
      roleChanged: false
    }
  },
  watch: {
    sourceContent () {
      this.onReload()
    }
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    
    onReload () {
      this.contentIndex = 0
      this.startAlert()
    },
    changeRole () {
      this.contentList.forEach(element => {
        element.isSent = !element.isSent
      })
      this.contentIndex = 0
      this.chatData = []
      this.onStart()
    },
    audioFinish () {
      if (this.contentIndex >= this.contentsLen - 1) {
        if (!this.roleChanged) {
          //역할 변경
          this.changeRole()
          this.roleChanged = true
        } else {
          this.onComplete()
        }
      } else {
        this.contentIndex++
        this.onStart()
      }
    },
    onStart () {
      this.chatData.push(this.content)
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    startAlert () {
      this.startStudyDlg('대화문을 학습 합니다.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        isSent: (contentJson.role[i] === '1'),
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }

    // this.contentList = [
    //   {
    //     sentence: 'Let\'s slide .',
    //     translation: '미끄럼틀을 타자.',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_01.mp3',
    //     isSent: false,
    //     isSeen: true
    //   },
    //   {
    //     sentence: 'Are you ready ?',
    //     translation: '준비됐니?',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_02.mp3',
    //     isSent: true
    //   },
    //   {
    //     sentence: 'Who is next ?',
    //     translation: '다음은 누구지?',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_03.mp3',
    //     isSent: false
    //   },
    //   {
    //     sentence: 'It is your turn.',
    //     translation: '너의 차례야.',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/W01/SPL01B03U01W010_04.mp3',
    //     isSent: true
    //   }
    // ]
    
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
  }
}

</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>